import FeaturedTitle from "./FeaturedTitle";
import React, { useEffect, useRef, useState } from "react";
import * as Text from "@/components/text";
import { motion } from "framer-motion";
import useWindowSize from "@/hooks/useWindowSize";
import breakpoints from "@/constants/breakpoinst";
import { Navigation, Pagination, Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";

const colorDir = {
  0: "hsla(208, 3%, 23%, 1)", // none
  13: "hsla(356, 100%, 70%, 1)", // gira
  14: "hsla(48, 100%, 64%, 1)", // ambulante presenta
  15: "hsla(40, 28%, 59%, 1)", // mas alla
};

export function TitlesSlider({ titles }) {
  const afterRef = useRef(null);
  const [color, setColor] = useState(0);
  const paginationRef = useRef(null);
  const beforeRef = useRef(null);
  const [slideIndex, setIndex] = useState(0);

  return (
    <div className="relative space-y-11 overflow-hidden">
      <div className="relative space-y-11 xl:mx-auto xl:max-w-[1440px]">
        <Swiper
          loop={true}
          observer={true}
          onActiveIndexChange={({ realIndex }) => {
            setIndex(realIndex);
          }}
          slidesPerView={1}
          breakpoints={{
            [breakpoints.xl]: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 24,
            },
            [breakpoints.lg]: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: -16,
            },
            [breakpoints.md]: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: -16,
            },
            [breakpoints.sm]: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: -16,
            },
          }}
          modules={[Thumbs, Navigation, Pagination]}
          pagination={{
            clickable: true,
            type: "bullets",
            el: paginationRef.current,
            currentClass: "bg-neutral-900",
            bulletClass: "block w-6 h-1 bg-gray-200 ",
            bulletActiveClass: "bg-neutral-900",
          }}
          navigation={{
            enabled: true,
            nextEl: ".after-button",
            prevEl: ".before-button",
            hiddenClass: "hidden",
            disabledClass: "text-neutral-50 border-neutral-50",
          }}
        >
          {titles.map(({ id, attributes: title }, i) => {
            return (
              <SwiperSlide key={id} className="flex justify-center">
                <FeaturedTitle
                  active={slideIndex === i}
                  setColor={setColor}
                  film_name={title.film_name}
                  slug={title.filmSlug}
                  original_title={title.film_original_title}
                  directors={title.Directores}
                  film_length={title.film_length}
                  countries={title.countries}
                  film_cover={title.film_cover_image}
                  initiatives={title.iniciativas}
                  film_year={title.film_year}
                  awards={title.awards}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div
          style={{ marginTop: 0 }}
          className="justify-center sm:flex md:flex lg:my-0 "
        >
          <div className="z-50 flex items-center justify-center gap-5 align-middle">
            <button
              ref={beforeRef}
              className="before-button absolute left-8 top-56 hidden bg-black/20  p-4 text-white/90  md:block"
            >
              <ArrowLeftIcon className="h-4 w-4 " />
            </button>
            <div className="flex gap-5" ref={paginationRef}></div>

            <button
              ref={afterRef}
              className="after-button z- absolute right-8 top-56 hidden bg-black/20 p-4 text-white/90  md:block"
            >
              <ArrowRightIcon className="h-4 w-4 " />
            </button>
          </div>
        </div>
      </div>
      <motion.div
        className="absolute top-0 h-[340px] w-full lg:h-[400px] xl:w-[100vw]"
        animate={{ backgroundColor: colorDir[color] }}
      ></motion.div>
    </div>
  );
}

export default function FeatureTitlesContainer({ featured }) {
  return (
    <>
      <TitlesSlider titles={featured} />
    </>
  );
}
